import { SvgProps } from "../../types";

const Share = (props: SvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={15}
    fill="none"
    {...props}>
    <path
      fill="#4C5269"
      fillRule="evenodd"
      d="M11.156 9.23a2.876 2.876 0 0 0-2.426 1.335L5.641 8.799c.2-.392.323-.83.323-1.299 0-.29-.056-.565-.136-.829l3.214-1.836a2.867 2.867 0 0 0 2.114.934A2.884 2.884 0 1 0 8.27 2.885c0 .29.056.564.136.83L5.193 5.55a2.87 2.87 0 0 0-2.114-.935 2.884 2.884 0 1 0 0 5.77 2.86 2.86 0 0 0 1.742-.6l3.482 2.019c-.012.104-.032.204-.032.311a2.884 2.884 0 1 0 2.885-2.884Z"
      clipRule="evenodd"
    />
  </svg>
);
export default Share;
